import MuiCard, { type CardProps as MuiCardProps } from "@mui/material/Card";
import MuiCardContent, { type CardContentProps } from "@mui/material/CardContent";
import MuiCardHeader, { type CardHeaderProps } from "@mui/material/CardHeader";
import MuiCardActions, { type CardActionsProps } from "@mui/material/CardActions";
import MuiCardMedia, { type CardMediaProps } from "@mui/material/CardMedia";
import type { SxProps, Theme } from "@mui/material/styles";

export type ForestCardColor = "primary" | "secondary";

export interface ForestCardProps extends Omit<MuiCardProps, "color"> {
  color?: ForestCardColor;
}

export type CardProps = ForestCardProps;
export type {
  CardContentProps,
  CardHeaderProps,
  CardActionsProps,
  CardMediaProps,
};

export function Card({ color = "primary", sx, ...props }: ForestCardProps) {
  return (
    <MuiCard
      {...props}
      sx={[
        color === "secondary" && { backgroundColor: "background.paper" },
        ...(Array.isArray(sx) ? sx : [sx as SxProps<Theme>]),
      ]}
    />
  );
}

export function CardContent(props: CardContentProps) {
  return <MuiCardContent {...props} />;
}

export function CardHeader(props: CardHeaderProps) {
  return <MuiCardHeader {...props} />;
}

export function CardActions(props: CardActionsProps) {
  return <MuiCardActions {...props} />;
}

export function CardMedia(props: CardMediaProps) {
  return <MuiCardMedia {...props} />;
}
